// Simples utilitário de notificações em memória
const listeners = new Set();
const notifications = [];

export function pushNotification(n) {
  const item = {
    id: Date.now() + Math.random(),
    title: n.title || 'Alerta',
    message: n.message || '',
    severity: n.severity || 'info',
    timestamp: new Date().toISOString(),
    projectId: n.projectId || null,
    taskId: n.taskId || null
  };
  notifications.push(item);
  for (const fn of listeners) {
    try { fn([...notifications]); } catch {}
  }
  return item.id;
}

export function subscribeNotifications(callback) {
  listeners.add(callback);
  // Emitir estado inicial
  try { callback([...notifications]); } catch {}
  return () => listeners.delete(callback);
}

export function getNotifications() {
  return [...notifications];
}

export function clearNotifications() {
  notifications.length = 0;
  for (const fn of listeners) {
    try { fn([]); } catch {}
  }
}

export function dismissNotification(id) {
  const idx = notifications.findIndex((n) => n.id === id);
  if (idx !== -1) {
    notifications.splice(idx, 1);
    for (const fn of listeners) {
      try { fn([...notifications]); } catch {}
    }
    return true;
  }
  return false;
}
